import {
  LottieAnimations,
  LottieView,
} from '@eCommerce/frontend-legacy-shared-library';
import {View} from 'native-base';

const PanelLoader = () => (
  <View
    bgColor="rgba(255,255,255, 0.9)"
    position="absolute"
    alignItems="center"
    justifyContent="center"
    left={0}
    right={0}
    top={0}
    bottom={0}
    zIndex={999}
  >
    <LottieView
      source={LottieAnimations.loaderAnimation}
      loop={true}
      style={{height: 64, width: 64}}
    />
  </View>
);

export default PanelLoader;
